<template>
    <div class="flex-1">
        <div class="flex flex-col sm:flex-row">
            <input-text
                class="w-1/2 pr-4"
                :name="'zoning_change_items[' + index + '][name]'"
                :value="item.name"
                :read_only="read_only"
            />

            <input-select
                class="w-1/4 pr-4"
                :name="'zoning_change_items[' + index + '][responsible]'"
                :value="item.responsible"
                :options="responsible"
                no_selection=""
            />

            <input-date
                class="w-1/4"
                :name="'zoning_change_items[' + index + '][completed_at]'"
                :value="item.completed_at"
                :read_only="read_only"
            />

            <input type="hidden" :name="'zoning_change_items[' + index + '][id]'" :value="item.id" />
        </div>
    </div>
</template>

<script>

export default {
    props: {
        index: {},
        item: { default: () => ({
            id: null,
            name: null,
            responsible: null,
            completed_at: null,
        }) },
        read_only: { default: false },
    },

    data() {
        return {
            responsible: [
                {
                    value: 'buyer',
                    label: 'Buyer',
                },
                {
                    value: 'seller',
                    label: 'Seller',
                },
                {
                    value: 'buyers_agent',
                    label: 'Buyer\'s Agent',
                },
                {
                    value: 'sellers_agent',
                    label: 'Seller\'s Agent',
                },
            ],
        }
    },

    computed: {
        index_for_array() {
            return this.index != null ? '[' + (this.index + 1) + ']' : '';
        },
    },
}
</script>
